import {getErrorMessageHtml, getInputErrorClasses} from "../../Utils/FormHelpers";
import {useTranslation} from "react-i18next";

export const TextAreaInput = (props) => {
    const {
        register,
        name,
        translationIndex,
        errors,
        rows = 5
    } = props;
    const {t} = useTranslation();

    return (
        <div>
            <label htmlFor={name}
                   className="block text-left text-sm font-medium leading-6 text-gray-900 h-auto">
                {t(translationIndex)}
            </label>

            <textarea
                {...register(name)}
                className={`block w-full mt-2 rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:outline-none focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 ${getInputErrorClasses(errors, name)}`}
                rows={rows}
            ></textarea>

            {getErrorMessageHtml(errors, name)}
        </div>
    )
}